import { render, staticRenderFns } from "./TrafficContentCN.vue?vue&type=template&id=0b334cfe&scoped=true"
import script from "./TrafficContentCN.vue?vue&type=script&lang=js"
export * from "./TrafficContentCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b334cfe",
  null
  
)

export default component.exports